export enum SalesOpportunityStatus {
  ACTIVE = 'ACTIVE',
  CONVERTED_TO_ORDER = 'CONVERTED_TO_ORDER',
  CONVERTED_TO_INVOICE = 'CONVERTED_TO_INVOICE',
  CONVERTED_TO_DELIVERY_NOTE = 'CONVERTED_TO_DELIVERY_NOTE',
  CONVERTED_TO_OFFER = 'CONVERTED_TO_OFFER',
  LOST = 'LOST',
  HIDE = 'HIDE',
}
